export const filterSearchResults = (results, category) => {
    const filteredResults = results.filter(result => {
        return result.category === category
    })

    return filteredResults
}
